<div>
    <br-breadcrumbs [maxItems]="maxItems"></br-breadcrumbs>
</div>